export default __webpack_public_path__ + "static/planet_hero-ac726a55e81d3825a794cc4ada77fb58.jpeg";